import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Field, Modal } from "@/components/rp";
import { AddressInput } from "@/components/AddressInput";
import { AccessData, ClientLogiFields } from "@/components/commesse";
import { Actions, useSubmit } from "@/components/admin/dialogs";

export const ClienteEditDialog = ({ c, open, onClose, onSaved }) => {
  const [f, setF] = useState(null);
  useEffect(() => { if (open) setF({ name: c.name, phone: c.phone || "", address: c.address || "", logistica: c.logistica || {} }); }, [open]); // eslint-disable-line
  const [loading, save] = useSubmit(async () => (await api.patch(`/admin/clients/${c.id}`, f)).data, (u) => { toast.success("Anagrafica aggiornata"); onSaved(u); onClose(); });
  if (!f) return null;
  return (
    <Modal open={open} onOpenChange={(o) => !o && onClose()} title="Modifica anagrafica" wide testid="client-edit-dialog"
      description="Indirizzo e dati dell'abitazione passano in automatico ai nuovi preventivi e cantieri del cliente.">
      <form onSubmit={save} className="space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Nome e cognome"><input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="rp-field" data-testid="client-edit-name" /></Field>
          <Field label="Telefono"><input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="rp-field" data-testid="client-edit-phone" /></Field>
        </div>
        <Field label="Indirizzo"><AddressInput value={f.address} onChange={(v) => setF({ ...f, address: v })} testid="client-edit-address" /></Field>
        <ClientLogiFields l={f.logistica} onChange={(v) => setF({ ...f, logistica: v })} />
        <Actions onCancel={onClose} loading={loading} label="Salva" testid="client-edit-save" />
      </form>
    </Modal>
  );
};

export const ClienteLogistica = ({ c }) => {
  const l = c.logistica || {};
  if (!Object.keys(l).length) return <p className="text-sm text-[#757575]" data-testid="client-logistica-empty">Nessun dato sull'abitazione: aggiungili da «Modifica anagrafica», passeranno ai preventivi e ai cantieri.</p>;
  return <AccessData x={{ ...l, logistica: l }} />;
};
